import type { LegalDoc } from '@/data/legalContent';
import { LEGAL_DRAFT_NOTICE } from '@/data/legalContent';
import s from './Auth.module.scss';

/** [2026-09-10] 약관·개인정보처리방침 전문 모달. legalContent.ts의 LegalDoc 렌더. */
export default function LegalModal({ doc, onClose }: { doc: LegalDoc | null; onClose: () => void }) {
	if (!doc) return null;
	return (
		<div className={s.modalBack} data-lenis-prevent onClick={onClose}>
			<div className={s.modal} onClick={(e) => e.stopPropagation()}>
				<div className={s.modalHead}>
					<h3>{doc.title}</h3>
					<button onClick={onClose} aria-label="닫기">×</button>
				</div>
				<div className={s.modalBody}>
					<div className={s.draftNote}>{LEGAL_DRAFT_NOTICE}</div>
					<p className={s.docMeta}>버전 {doc.version} · 시행일 {doc.effectiveDate}</p>
					{doc.sections.map((sec, i) => (
						<div key={i} className={s.docSection}>
							<h4>{sec.heading}</h4>
							{sec.body.map((p, j) => <p key={j}>{p}</p>)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
